"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var Tag = function (_a) {
    var _b = _a.closable, closable = _b === void 0 ? false : _b, closeIcon = _a.closeIcon, color = _a.color, icon = _a.icon, _c = _a.visible, visible = _c === void 0 ? true : _c, onClose = _a.onClose, title = _a.title;
    return (react_1.default.createElement(antd_1.Tag, { closable: closable, closeIcon: closeIcon, color: color, icon: icon, visible: visible, onClose: onClose }, title));
};
exports.default = Tag;
